import $ from 'jquery'
var AudioPlayer = function(selector) {
    this._activeAudioId = null
    this.selector = selector || '#audioPlayer'
    this._audio = $(this.selector)[0]

    this._isPlaying = false

    this._events = {}
}

AudioPlayer.events = {
    ENDED: 'ended',
    LOADED: 'loadeddata',
}

AudioPlayer.prototype.stop = function() {
    this._isPlaying = false
    this._audio.pause()
}

AudioPlayer.prototype.play = function() {
    var url = this.getUrl()
    if (url == '' || typeof url == 'undefined') return
    this._isPlaying = true
    this._audio.play()
}

AudioPlayer.prototype.setUrl = function(file) {
    if (!file || $(this.selector).attr('src') == file) return
    $(this.selector).attr('src', file)
}

AudioPlayer.prototype.getUrl = function() {
    return $(this.selector).attr('src')
}

AudioPlayer.prototype.isPlaying = function() {
    return this._isPlaying
}

AudioPlayer.prototype.ended = function() {
    return this._audio.ended || this._audio.currentTime >= this._audio.duration
}

AudioPlayer.prototype.onEnded = function(cb) {
    this._events[AudioPlayer.events.ENDED] = cb
    this._audio.addEventListener(AudioPlayer.events.ENDED, cb)
}

AudioPlayer.prototype.onLoaded = function(cb) {
    this._events[AudioPlayer.events.LOADED] = cb
    this._audio.addEventListener(AudioPlayer.events.LOADED, cb)
}

AudioPlayer.prototype.currentTime = function(currentTime) {
    this._audio.currentTime = currentTime
}

AudioPlayer.prototype.destroy = function() {
    this.stop()

    for (var eventName in this._events) {
        this._audio.removeEventListener(eventName, this._events[eventName])
    }

    this._events = null
}

export default AudioPlayer
